// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__a-nmy","title":"ClientInsurance_title__1yL2v","itemText":"ClientInsurance_itemText__1LiBc"};